import React from 'react';

const footer = () => {
    return (
    <div className="main-footer">
        <p>Designed &amp; Developed by Rojina Deuja | 2021</p>
        {/* <div>
            <a href="#"><i className="fa fa-chevron-circle-down footer-chevron"></i></a>
        </div>     */}
    </div>)
}

export default footer;